











import {Component, Vue} from 'vue-property-decorator';
@Component({
  name:"IComment"
})
export default class IComment extends Vue{

}
